export type AppRouteKey =
  | 'mainPage'
  | 'aboutPage'
  | 'operationOld'
  | 'toolPage'
  | 'pricingPage'
  | 'ordersPage'
  | 'other';

const appRoutes: Record<AppRouteKey, string> = {
  mainPage: '/',
  aboutPage: '/about',
  operationOld: 'operation',
  toolPage: 't',
  pricingPage: '/pricing',
  ordersPage: '/orders',
  other: '/404',
};

const getAppRoute = (key: AppRouteKey): string => {
  return appRoutes[key] || appRoutes.other;
};

export { appRoutes, getAppRoute };
